<template>
  <base-dialog
    @save-item="saveItem"
    dialogId="edit-portal-model-dialog"
    :open.sync="openDialog"
    :form-ref.sync="portalModelFormRef"
    :loading.sync="isLoading"
  >
    <template v-slot:[`dialog.title`]>
      <span>Modifier un modèle de portail</span>
    </template>
    <template v-slot:[`dialog.content`]>
      <v-container>
        <portal-model-form
          :portal-model-form.sync="portalModelForm"
          :rules="rules"
        ></portal-model-form>
      </v-container>
    </template>
    <template v-slot:[`dialog.actions.save`]>Modifier</template>
  </base-dialog>
</template>
<script>
import { onMounted, toRefs, computed } from "@vue/composition-api";
import PortalModelForm from "@/components/PortalModel/PortalModelForm";
import { usePortalModel } from "@/composables/portal-model";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    PortalModelForm,
    BaseDialog,
  },
  props: {
    portalModel: Object,
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { portalModelData, updatePortalModel } = usePortalModel();

    /* Variables */
    const { name, url, configuration } = props.portalModel;

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await updatePortalModel(props.portalModel);
      openDialog.value = false;
    };

    /* Cycle de vie */
    onMounted(() => {
      portalModelData.portalModelForm = {
        name,
        url,
        configuration: JSON.stringify(configuration),
      };
    });

    return {
      updatePortalModel,
      ...toRefs(portalModelData),
      openDialog,
      saveItem,
    };
  },
};
</script>
